import React from 'react'
import type { TextContentBlock as TextContentBlockProps } from '@/payload-types'
import { RichText } from '@payloadcms/richtext-lexical/react'

export function TextContentBlock({
  title,
  lead,
  content,
}: Readonly<TextContentBlockProps>): React.ReactNode {
  return (
    <section className="group p-8">
      <div className="flex flex-col max-w-4xl mx-auto gap-8">
        {title || lead ? (
          <header className="lg:flex-1 flex flex-col gap-4 self-center p-8">
            {title ? <h2 className="text-lg lg:text-xl font-semibold">{title}</h2> : null}
            {lead ? <p className="text-sm">{lead}</p> : null}
          </header>
        ) : null}
        <RichText data={content} className="prose prose-neutral" />
      </div>
    </section>
  )
}
